import { useTranslation } from "react-i18next";
import { contactsIsEditSelector } from "@/pages/ContactsPage/slice";
import { useAppSelector } from "@/services/store";
import { FormInput } from "@/shared/Components";

export const TitleField = () => {
  const { t } = useTranslation();

  const isEdit = useAppSelector(contactsIsEditSelector);
  if (!isEdit) return <></>;
  return <FormInput name="title" placeholder={t("common.title")} />;
};
